module.exports = __webpack_public_path__ + "static/media/checkbox.04c3f407.md";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/checkbox.md
// module id = 369
// module chunks = 0